import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SPACE_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  Space,
  SpacePostBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  spaceId: string
  params: SpacePostBody
  children?: (response: Space) => ReactElement
  onSuccess?: (response: Space) => void
  onError?: (error: Error) => void
}

const SaveSpaceRequest = ({
  spaceId,
  params,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${SPACE_SERVICE}/spaces/${spaceId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default SaveSpaceRequest
